import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Grid,
  MenuItem,
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
  ListItemIcon,
  Radio,
  ListItemButton,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { searchPayload } from "../../../utils/common";
import CustomTextField from "../../../components/CustomTextField";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import useUser from "../../../hooks/useUser";
import useComplaintType from "../../../hooks/useComplaintType";
import useEmployee from "../../../hooks/useEmployee";
import useTenant from "../../../hooks/useTenant";
import useAuth from "../../../hooks/useAuth";
import UserSearch from "../../../components/UserSearch";
import UserDetails from "./UserDetails";
import useComplaint from "../../../hooks/useComplaint";
import ComplaintHistoryTimeline from "./ComplaintHistoryTimeline";
import CustomRadioBox from "../../../components/CustomRadioBox";
import CustomCheckBox from "../../../components/CustomCheckBox";
import CustomerComplaintDataGrid from "./CustomerComplaintDataGrid";
import { height } from "@mui/system";
import ComplaintTimeline from "./ComplaintTimeLine";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};
const existingComplaints = [
  { id: "C-1001", issue: "Fiber Cut", status: "Open", area: "Zone A", date: "2025-08-25" },
  { id: "C-1002", issue: "Slow Speed", status: "In Progress", area: "Zone B", date: "2025-08-24" },
];

function ComplaintFields(props) {
  const { fields, hideAssignee, selectedComplaint, setSelectedComplaint } = props;
  const {
    searchComplaint,
    complaintSearchResults,
    getComplaint,
    complaint: data,
    getAllCustomerComplaint,
    customerComplaints,
    paging,
    isLoading,
  } = useComplaint();

  const [selectedRows, setSelectedRows] = useState([]);
  const [businessType, setBusinessType] = useState("");
  const {
    autoSearchUser,
    userAutoSearchResults,
    getUser,
    autoSearchLoading,
    user: radUser,
    setEmptyUser,
  } = useUser();

  const searchPayloadValue = searchPayload();

  const { autoSearchComplaintType, complaintTypeAutoSearchResults } = useComplaintType();
  const { autoSearchEmployee, employeeAutoSearchResults } = useEmployee();
  const { autoSearchTenant, tenantAutoSearchResults } = useTenant();
  const { user } = useAuth();

  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  const selectedUser = watch("selectedUser");
  const selectedComplaintType = watch("complaintType");
  const selectedArea = watch("area");

  const [payload, setPayload] = useState({});

  const [userOptions, setUserOptions] = useState([]);
  const [complaintTypeOptions, setComplaintTypeOptions] = useState([]);
  const [complaintTypePayload, setComplaintTypePayload] = useState(currentPayload);
  const [userPayload, setUserPayload] = useState(searchPayloadValue);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeePayload, setEmployeePayload] = useState(currentPayload);

  const fetchSimilarComplaints = async () => {
    await searchComplaint({
      filters: [
        {
          fieldName: "complaintTypeId",
          fieldValue: selectedComplaintType?.value,
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
          entityName: "ComplaintEntity",
          attributeName: "complaintType",
        },
        {
          fieldName: "area",
          fieldValue: selectedArea,
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: false,
        },
      ],
      pagination: {
        pageNumber: 1,
        pageSize: 100,
      },
      sortFields: [],
    });
  };

  useEffect(() => {
    if (selectedUser != undefined && Object.keys(selectedUser).length != 0) {
      getUser(selectedUser.value);
    } else {
      setEmptyUser();
    }
  }, [selectedUser]);

  useEffect(() => {
    console.log(selectedArea, "selectedArea");
    if (selectedComplaintType != null && selectedArea != undefined && selectedArea != "") {
      fetchSimilarComplaints();
    } else {
    }
    console.log(selectedComplaintType, "selectedComplaintType");
  }, [selectedComplaintType, selectedArea]);

  useEffect(() => {
    console.log(userAutoSearchResults, "userAutoSearchResults");
    if (userAutoSearchResults && userAutoSearchResults.data.length !== 0) {
      const results = [...userOptions, ...userAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setUserOptions(filteredResults);
    }
  }, [userAutoSearchResults]);

  // complaintType

  const fetchComplaintType = async () => {
    await autoSearchComplaintType(complaintTypePayload);
  };
  useEffect(() => {
    fetchComplaintType();
  }, [complaintTypePayload]);

  useEffect(() => {
    console.log(user, "user.businessType");
    setBusinessType(user ? user.businessType : "");
    if (user && user.businessType == "USER") {
      setValue("selectedUser", { label: user.username, value: user.radUserId });
    }
  }, [user]);

  const fetchUsers = async (payload) => {
    await autoSearchUser(payload);
  };

  useEffect(() => {
    console.log(complaintTypeAutoSearchResults, "complaintTypeAutoSearchResults");
    if (complaintTypeAutoSearchResults && complaintTypeAutoSearchResults.data.length !== 0) {
      const results = [...complaintTypeOptions, ...complaintTypeAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setComplaintTypeOptions(filteredResults);
    }
  }, [complaintTypeAutoSearchResults]);

  // employee

  const fetchEmployee = async () => {
    await autoSearchEmployee(employeePayload);
  };
  useEffect(() => {
    fetchEmployee();
  }, [employeePayload]);

  useEffect(() => {
    console.log(employeeAutoSearchResults, "employeeAutoSearchResults");
    if (employeeAutoSearchResults && employeeAutoSearchResults.data.length !== 0) {
      const results = [...employeeOptions, ...employeeAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setEmployeeOptions(filteredResults);
    }
  }, [employeeAutoSearchResults]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (tenantAutoSearchResults.data.length !== 0) {
      const results = [...tenantOptions, ...tenantAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setTenantOptions(filteredResults);
    }
  }, [tenantAutoSearchResults]);

  const fetchCustomerComplaintData = async () => {
    console.log(payload, "payload0909");
    if (Object.keys(payload).length != 0) {
      await getAllCustomerComplaint(payload);
    }
  };
  useEffect(() => {
    fetchCustomerComplaintData();
  }, [payload]);

  const [filteredComplaints, setFilteredComplaints] = useState([]);

  useEffect(() => {
    let complaintHistories = customerComplaints.filter((data) =>
      selectedRows.includes(data.customerComplaintId),
    );
    setFilteredComplaints(complaintHistories);
  }, [selectedRows]);

  return (
    <Grid container spacing={4}>
      {/* Left Column */}
      <Grid item xs={12} md={6}>
        <Grid container spacing={6}>
          {/* User Search */}
          {businessType != "USER" && (
            <Grid item xs={12}>
              <UserSearch />
            </Grid>
          )}

          {/* Complaint Type */}
          <Grid item xs={12}>
            <SearchableAutoComplete
              control={control}
              data={complaintTypeOptions}
              label={t("complaint_type")}
              name="complaintType"
              fullWidth
              variant="outlined"
              errors={errors}
              payload={complaintTypePayload}
              setPayload={setComplaintTypePayload}
              loading={false}
              multiple={false}
              defaultValue=""
              hasNextPage={false}
              fields={fields}
            />
          </Grid>

          <Grid item xs={12}>
            <UserDetails user={radUser} />
          </Grid>
        </Grid>
      </Grid>

      {/* Right Column */}
      <Grid item xs={12} md={6}>
        <Grid container spacing={6}>
          {businessType != "USER" && (
            <Grid item xs={12}>
              <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
                <CardHeader title={t("similar_complaints")} />
                <CardContent>
                  {complaintSearchResults?.length > 0 ? (
                    <List
                      sx={{
                        maxHeight: 200, // set the max height (px or rem as needed)
                        overflowY: "auto", // enable vertical scroll
                      }}
                    >
                      {complaintSearchResults.map((c) => (
                        <ListItem
                          key={c.complaintId}
                          disablePadding
                          onClick={() => setSelectedComplaint(c)}
                        >
                          <ListItemButton
                            selected={selectedComplaint?.complaintId === c.complaintId}
                          >
                            <ListItemIcon>
                              <Radio
                                edge="start"
                                checked={selectedComplaint?.complaintId === c.complaintId}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ "aria-labelledby": `complaint-${c.complaintId}` }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              id={`complaint-${c.complaintId}`}
                              primary={`${c.complaintNo} - ${c.complaintType?.complaintTypeName}`}
                              secondary={`${c.area} | ${c.status} | ${c.complaintDate}`}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      {t("no_similar_complaints_found")}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          )}
          <Grid item xs={12}>
            <ReactHookFormSelect
              name="category"
              label={t("category")}
              control={control}
              fullWidth
              variant="outlined"
              errors={errors}
              fields={fields}
            >
              <MenuItem value="NETWORK">Network</MenuItem>
              <MenuItem value="FIBER">Fiber</MenuItem>
              <MenuItem value="ACCOUNTS">Accounts</MenuItem>
              <MenuItem value="SALES">Sales</MenuItem>
            </ReactHookFormSelect>
          </Grid>

          {/* Priority */}
          <Grid item xs={12}>
            <CustomRadioBox
              label={t("priority")}
              name="priority"
              control={control}
              options={[
                { value: "IMMEDIATE", label: "IMMEDIATE" },
                { value: "HIGH", label: "HIGH" },
                { value: "MEDIUM", label: "MEDIUM" },
                { value: "LOW", label: "LOW" },
              ]}
              errors={errors}
            />
          </Grid>

          {/* Comments */}
          <Grid item xs={12}>
            <CustomTextField
              multiline
              rows={3}
              maxRows={6}
              label={t("complaint_details")}
              name="complaintDetails"
              control={control}
              fullWidth
              variant="outlined"
              errors={errors}
              fields={fields}
            />
          </Grid>
        </Grid>
      </Grid>
      {businessType != "USER" && (
        <Grid item xs={12}>
          <Typography variant="h5" fontWeight={700}>
            Complaint History
          </Typography>
          <CustomerComplaintDataGrid
            complaintId={null}
            fetchData={null}
            selectedUser={selectedUser}
            setSelectedRows={setSelectedRows}
            isLoadedFromAddComplaintField={true}
            checkboxSelection={true}
            setBusinessType={businessType}
          />
        </Grid>
      )}
      {businessType != "USER" && (
        <Grid item xs={12}>
          <ComplaintTimeline filteredComplaints={filteredComplaints} />
        </Grid>
      )}
    </Grid>
  );
}

export default ComplaintFields;
